import { getPreferredLocale } from '@/services/locale.service';

export function formatArticleDisplayDate(value) {
  if (!value) return null;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const now = new Date();
  const isCurrentYear = date.getFullYear() === now.getFullYear();

  return date.toLocaleDateString(getPreferredLocale(), {
    day: 'numeric',
    month: 'short',
    ...(isCurrentYear ? {} : { year: '2-digit' }),
  });
}
